import React from "react"
import "./style.css"
import LogoSegmais from "../../../assets/BannerSegMais.png"

export default function Paciente() {
  return (
    <div className="pacient-data">

      <div className="segmais">
        <figure>
          <a
            href="https://api.whatsapp.com/send?phone=2126665800"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={LogoSegmais} alt="Segmais" />
          </a>
        </figure>
      </div>

      <div id="patient-disclaimer">
        <p id="patient-disclaimer_warning" >
          - Você será cobrado somente no dia da consulta; <br />- Chegar na
          unidade com 30 minutos de antecedência. <br />- Não esqueça de trazer seus
          documentos de identificação com foto.
        </p>

        <p id="patient-disclaimer_legal">
          - Para fins de identificação e cumprimento de exigências legais, é imprescindível a apresentação de documento oficial de identidade com foto no ato do atendimento.
          <br />
          Os serviços agendados por esta plataforma não podem ser editados. Caso necessário, entre em contato pelo telefone 2666-5800 ou via WhatsApp para solicitar alterações. Cancelamentos ou confirmações devem ser realizados diretamente na Área do Paciente.
          <br />
          Esta página é protegida pelo Google reCAPTCHA para garantir que você não é um robô. <a href="https://policies.google.com/privacy">Saiba mais</a>
        </p>

      </div>

    </div>
  )
}
